import React from "react";
import SuperAdminReports from "../superadmin/dashboard/ReportsPage";

const ReportsPage = () => {
    return <SuperAdminReports />;
};

export default ReportsPage;
